import { createElement } from '../lib/createElement'

addEventListener('DOMContentLoaded', () => {
	// Find all anchors with class 'open-popup'
	const anchors = document.querySelectorAll('a.open-popup')
	for (let a = 0; a < anchors.length; a++) {
		anchors[a].addEventListener('click', function (event) {
			event.preventDefault()

			new Popup({
				className: this.className,
				href: this.href,
			})
		})
	}
})

class Popup {
	static closeAll() {
		const popups = document.querySelectorAll('div.popup')
		for (let a = 0; a < popups.length; a++) {
			popups[a].remove()
		}
	}

	constructor(options) {
		const { className = '', href } = options
		if (!href) {
			return
		}

		this.iframe = createElement('iframe', { src: href })

		this.closeButton = createElement('a', {
			className: 'close-button',
			onClick: this.close,
		})

		this.content = createElement('div', { className: 'popup-content' }, this.closeButton, this.iframe)
		this.dom = createElement('div', { className: 'popup ' + className }, this.content)
		document.body.appendChild(this.dom)
	}

	close = () => {
		this.dom.remove()
	}
}
